/* 店舗リスト（/pages/shoplist）— Storefront API からメタオブジェクトを取得して描画する。
 *
 * 背景（2026-09-05 実測）:
 *   Liquid の shop.metaobjects は .size こそ総数を返すが、ループできるのは先頭50件まで。
 *   where で都道府県を絞っても50件の中でしか効かないため、Liquid では一覧を組めない。
 *   Storefront API 側にも type 以外のフィルタ引数がないので、全件取得してブラウザ側で分類する。
 *   実測で 5,561件を23ページ・約5秒で取得できることを確認済み。
 *
 * 非公開（DRAFT）のエントリは Storefront API から返らないため、公開分だけが自動的に並ぶ。
 * 公開日（publish_date・2026-10-15 追加）が未来のものは、その日になるまで出さない（サロン・オンライン正規店）。
 *
 * オンライン正規店（2026-10-05）:
 *   旧 shoplist_agency は「1件＝1社・店舗15枠」で、枠が足りない会社（Salon.EC）は同じ会社を何十行にも分けて
 *   登録していたため、見出しが重複して並んでいた。9/29定例の決定で「1件＝1店舗」の shoplist_agency_shop に作り替え、
 *   表示時に「掲載グループ → 会社名＋認証番号」ごとに見出しを1つにまとめる。
 *   shoplist_agency_shop が空のあいだ（データ投入前）は、旧 shoplist_agency で従来どおり表示する。
 */
(function () {
  var CFG = window.KINUJO_SHOPLIST;
  if (!CFG || !CFG.token) return;

  var ENDPOINT = 'https://' + CFG.domain + '/api/' + CFG.version + '/graphql.json';
  var CACHE_KEY = 'kinujo_shoplist_v2';
  var CACHE_TTL = 30 * 60 * 1000; // 30分

  function gql(query, variables) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CFG.token
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); });
  }

  var QUERY = [
    'query Q($type: String!, $after: String) {',
    '  metaobjects(type: $type, first: 250, after: $after) {',
    '    nodes { handle fields { key value } }',
    '    pageInfo { hasNextPage endCursor }',
    '  }',
    '}'
  ].join('\n');

  function fetchAll(type) {
    var out = [];
    function page(after) {
      return gql(QUERY, { type: type, after: after }).then(function (res) {
        if (!res || !res.data) throw new Error('取得に失敗しました');
        var d = res.data.metaobjects;
        d.nodes.forEach(function (n) {
          var o = {};
          n.fields.forEach(function (f) { if (f.value) o[f.key] = f.value; });
          out.push(o);
        });
        if (d.pageInfo.hasNextPage) return page(d.pageInfo.endCursor);
        return out;
      });
    }
    return page(null);
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c.at || Date.now() - c.at > CACHE_TTL) return null;
      return c.data;
    } catch (e) { return null; }
  }

  function writeCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), data: data }));
    } catch (e) { /* 容量超過などは無視（キャッシュは無くても動く） */ }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* 公開日（publish_date・日付）が未来のエントリは、その日の0時（日本時間）まで出さない。空欄は即表示 */
  function todayJST() {
    return new Date(Date.now() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);
  }
  function isPublished(o) {
    return !o.publish_date || o.publish_date <= todayJST();
  }

  /* ---- サロン ---- */
  function salonItem(s) {
    var tel = s.tel
      ? '<span class="shop__tel">TEL :<a href="tel:' + esc(s.tel) + '">' + esc(s.tel) + '</a></span>'
      : '';
    return '<li class="shop" data-name="' + esc(s.name) + '" data-address="' + esc(s.address) + '">'
      + '<h3 class="shop__name">' + esc(s.name) + '</h3>'
      + '<address class="shop__address">'
      + '<span class="shop__address-postal">' + esc(s.address) + '</span>'
      + tel
      + '</address></li>';
  }

  function renderSalons(list) {
    var byPref = {};
    list.forEach(function (s) {
      var p = s.prefecture || '';
      if (!p || !isPublished(s)) return;
      (byPref[p] = byPref[p] || []).push(s);
    });
    var lists = document.querySelectorAll('ul.shop-list[data-pref]');
    Array.prototype.forEach.call(lists, function (ul) {
      var pref = ul.getAttribute('data-pref');
      var items = byPref[pref] || [];
      ul.innerHTML = items.map(salonItem).join('');
      var region = ul.closest('.area-list__region');
      if (region && !items.length) region.setAttribute('data-empty', '1');
    });
  }

  /* ---- オンライン正規店 ---- */
  // a = { name, certification, shops: [{ name, url }] }
  function agencyItem(a) {
    var shops = a.shops.map(function (sh) {
      if (sh.url) {
        return '<li>' + esc(sh.name || '') + '<a href="' + esc(sh.url) + '" rel="external" target="_blank">' + esc(sh.url) + '</a></li>';
      }
      return '<li>' + esc(sh.name) + '</li>';
    });
    return '<ul class="accordion__group__items"><li class="accordion__group__item">'
      + '<div class="accordion__group__item__hed"><h6>' + esc(a.name) + '</h6>'
      + '<span>（認証番号：' + esc(a.certification) + '）</span></div>'
      + '<ul class="accordion__group__item__content">' + shops.join('') + '</ul>'
      + '</li></ul>';
  }

  // 新形式（1件＝1店舗）: 表示順に並べ、掲載グループごとに「会社名＋認証番号」で見出しをまとめる
  function groupShops(list) {
    var sorted = list.slice().sort(function (x, y) {
      return (parseInt(x.sort_order, 10) || 0) - (parseInt(y.sort_order, 10) || 0);
    });
    var byGroup = {};
    sorted.forEach(function (r) {
      var g = r.group || '';
      if (!g) return;
      var G = byGroup[g] = byGroup[g] || { order: [], map: {} };
      var key = (r.name || '') + '|' + (r.certification || '');
      if (!G.map[key]) {
        G.map[key] = { name: r.name, certification: r.certification, shops: [] };
        G.order.push(key);
      }
      if (r.shop_name || r.shop_url) G.map[key].shops.push({ name: r.shop_name, url: r.shop_url });
    });
    var out = {};
    Object.keys(byGroup).forEach(function (g) {
      out[g] = byGroup[g].order.map(function (k) { return byGroup[g].map[k]; });
    });
    return out;
  }

  // 旧形式（1件＝1社・店舗15枠）: データ投入前の切り替え待ち用
  function groupLegacy(list) {
    var out = {};
    list.forEach(function (a) {
      var g = a.group || '';
      if (!g) return;
      var shops = [];
      for (var i = 1; i <= 15; i++) {
        var n = a['shop_name' + i], u = a['shop_url' + i];
        if (n || u) shops.push({ name: n, url: u });
      }
      (out[g] = out[g] || []).push({ name: a.name, certification: a.certification, shops: shops });
    });
    return out;
  }

  function renderAgencies(data) {
    var byGroup = data.agencyShops && data.agencyShops.length
      ? groupShops(data.agencyShops.filter(isPublished))
      : groupLegacy(data.agencies || []);
    var boxes = document.querySelectorAll('[data-agency-group]');
    Array.prototype.forEach.call(boxes, function (box) {
      var g = box.getAttribute('data-agency-group');
      var items = byGroup[g] || [];
      box.innerHTML = items.map(agencyItem).join('');
    });
  }

  /* ---- 検索 ---- */
  function setupSearch() {
    var input = document.getElementById('search-input');
    if (!input) return;
    var form = input.form;
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); });

    var timer = null;
    function apply() {
      var q = input.value.trim().toLowerCase();
      var hitTotal = 0;
      var regions = document.querySelectorAll('.area-list__region');
      Array.prototype.forEach.call(regions, function (region) {
        var shops = region.querySelectorAll('li.shop');
        var hit = 0;
        Array.prototype.forEach.call(shops, function (li) {
          var text = (li.getAttribute('data-name') + ' ' + li.getAttribute('data-address')).toLowerCase();
          var ok = !q || text.indexOf(q) !== -1;
          li.style.display = ok ? '' : 'none';
          if (ok) hit++;
        });
        hitTotal += hit;
        // 検索中はヒットした県だけ開いて見せる
        if (q) {
          region.style.display = hit ? '' : 'none';
          region.setAttribute('data-search-open', hit ? '1' : '');
        } else {
          region.style.display = region.getAttribute('data-empty') ? 'none' : '';
          region.removeAttribute('data-search-open');
        }
      });
      var status = document.getElementById('js-search-status');
      if (status) status.textContent = q ? hitTotal + '件見つかりました' : '';
      document.body.classList.toggle('is-shoplist-searching', !!q);
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 200);
    });
  }

  function setStatus(msg) {
    var el = document.getElementById('js-shoplist-status');
    if (el) el.textContent = msg;
  }

  function boot() {
    var cached = readCache();
    if (cached) {
      renderSalons(cached.salons);
      renderAgencies(cached);
      setStatus('');
      setupSearch();
      return;
    }
    setStatus('店舗情報を読み込んでいます…');
    Promise.all([
      fetchAll('shoplist_salon'),
      // 新形式が空（データ投入前）のときだけ旧形式を読む
      fetchAll('shoplist_agency_shop').then(function (shops) {
        return shops.length ? { agencyShops: shops } : fetchAll('shoplist_agency').then(function (a) { return { agencies: a }; });
      })
    ])
      .then(function (r) {
        var data = { salons: r[0], agencyShops: r[1].agencyShops || null, agencies: r[1].agencies || null };
        renderSalons(data.salons);
        renderAgencies(data);
        writeCache(data);
        setStatus('');
        setupSearch();
      })
      .catch(function (e) {
        setStatus('店舗情報を読み込めませんでした。時間をおいて再度お試しください。');
        if (window.console) console.error('[shoplist]', e);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
